import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

/**
 * Lean row returned by the `/funds/mobile-list` endpoint (the mobile funds browse list).
 * Only what a mobile row renders: id, name, closed capital, FMV, MOIC — the backend
 * `view__funds_mobile_list` RPC skips the funds grid's ~79 columns (incl. cashflows for
 * IRR, which mobile doesn't show). All preformatted (`*_fmt`). `.passthrough()` stays
 * tolerant of any extra keys.
 */
export const FundMobileListRecordSchema = z
  .object({
    funds__id: z.string(),
    funds__name: z.string().nullish(),
    funds__closed_capital_fmt: z.string().nullish(),
    fmv_fmt: z.string().nullish(),
    moic_fmt: z.string().nullish()
  })
  .passthrough()

export type FundMobileListRecord = z.infer<typeof FundMobileListRecordSchema>

export function validateFundMobileListRecord(
  data: unknown,
  options?: { isArray?: boolean }
): FundMobileListRecord | FundMobileListRecord[] {
  return validateWithZodSchema(FundMobileListRecordSchema, data, 'fund mobile list record', options) as
    | FundMobileListRecord
    | FundMobileListRecord[]
}
